import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'parcel-receptacle-users' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
